import type { ReactNode } from 'react';

export const symbol_metabolism: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M399-247v-140h-59v-143q0-21 28.5-34t74.5-13q46 0 74.5 13t28.5 34v143h-59v140h-88Zm5.5-374.5Q389-637 389-660t15.5-38.5Q420-714 443-714t38.5 15.5Q497-683 497-660t-15.5 38.5Q466-606 443-606t-38.5-15.5ZM443-116q-152 0-258-106T79-480q0-76 28.5-142t78-115.5Q235-787 301-815.5T443-844q76 0 142 28.5t115.5 78Q750-688 778.5-622T807-480v18l49-49q9-9 21-9t21 9q9 9 9 21t-9 21L798-369q-9 9-21 9t-21-9L656-469q-9-9-9-21t9-21q9-9 21-9t21 9l49 49v-18q0-125-89.5-214.5T443-784q-125 0-214.5 89.5T139-480q0 125 89.5 214.5T443-176q49 0 96-16t85-45q11-8 22.5-7.5T667-235q9 9 9 21.5T666-193q-46 35-104.5 56T443-116Z"
		/>
	</svg>
);
